import { aboutData } from '@/mocks/home';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            {aboutData.title}
          </h2>
        </div>

        <div className="bg-background-50 rounded-xl p-6 md:p-8 mb-8">
          {aboutData.content.split('\n\n').map((paragraph, i) => (
            <p key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4 last:mb-0">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {aboutData.stats.map((stat, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-4 md:p-5 text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}